<div class="filter-wrap">
    <input type="checkbox"
           [checked]="isActive" />
    <label title="{{ viewValue || filterValue }}">{{ viewValue || filterValue }}
        <span *ngIf="!hideCount" class="ng-filter-value-count">({{ count }})</span>
    </label>
</div>
